import Swal from "sweetalert2";

export const ErrorSessionNoLongerExists = () => {
  return Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Error: A request was received from a session that no longer exists.",
  });
};
